import { useNavigate } from 'react-router-dom';

function MarketingLinks() {
  const navigate = useNavigate();

  return (
    <div className="mb-6 flex flex-wrap gap-4">
      <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <button
          onClick={() => navigate('/admin', { state: { activeTab: 'promos' } })}
          className="text-blue-700 hover:text-blue-900 font-medium underline flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
          </svg>
          Promos
        </button>
      </div>
      <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
        <a
          href="/admin/visitor-activity"
          className="text-green-700 hover:text-green-900 font-medium underline flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          Visitor Activity
        </a>
      </div>
      <div className="p-4 bg-teal-50 border border-teal-200 rounded-lg">
        <a
          href="/admin/visitor-analysis"
          className="text-teal-700 hover:text-teal-900 font-medium underline flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          Visitor Analysis
        </a>
      </div>
      <div className="p-4 bg-teal-50 border border-teal-200 rounded-lg">
        <a
          href="/admin/contact-inquiries"
          className="text-teal-700 hover:text-teal-900 font-medium underline flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          Contact Inquiries
        </a>
      </div>
      <div className="p-4 bg-purple-50 border border-purple-200 rounded-lg">
        <a
          href="/admin/mailing-list"
          className="text-purple-700 hover:text-purple-900 font-medium underline flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          Mailing List
        </a>
      </div>
      <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
        <a
          href="/admin/outreach"
          className="text-amber-700 hover:text-amber-900 font-medium underline flex items-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          Outreach
        </a>
      </div>
    </div>
  );
}

export default MarketingLinks;
